import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { NoteModule } from '../../../../../note/note.module';
import { SharedPipesModule } from '../../../../../shared/pipes/shared-pipes.module';
import { SharedValidatorsModule } from '../../../../../shared/validators/shared-validators.module';
import { SharedComponentsModule } from '../../../../../shared/components/shared-components.module';
import { ValidationResultsModule } from '../../../../../shared/components/validation-results/validation-results.module';
import { ModelParserService } from '../../../../../titleregistration/services/model-parser.service';
import { VehicleAddComponent } from './vehicle-add.component';
import { VehicleAddService } from './vehicle-add.service';
import { VehicleBrandsComponent } from '../../../../shared/vehicle-brands/vehicle-brands.component';
import { VehicleMakeModelComponent } from '../../../../shared/vehicle-make-model/vehicle-make-model.component';
import { VehicleMakeModelService } from '../../../../shared/vehicle-make-model/vehicle-make-model.service';

@NgModule({
    declarations: [
        VehicleAddComponent,
        VehicleMakeModelComponent,
        VehicleBrandsComponent
    ],
    providers: [
        VehicleAddService,
        ModelParserService,
        VehicleMakeModelService
    ],
    imports: [
        CommonModule,
        FormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        ReactiveFormsModule,
        CalendarModule,
        NoteModule,
        SharedComponentsModule,
        SharedPipesModule,
        SharedValidatorsModule,
        ValidationResultsModule
    ],
    exports: [
        VehicleAddComponent,
        VehicleMakeModelComponent,
        VehicleBrandsComponent
    ]
})
export class VehicleAddModule {
}
